<template>
  <Modal
    class="create-update-modal"
    :mask-closable="false"
    :closable="false"
    :title="`修改状态`"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="110">
      <Row>
        <Col :sm="24" :xs="24">
          <FormItem label="修改状态:" prop="status">
            <RadioGroup v-model="handleForm.status">
							<Radio
								v-for="item in statusList"
								:key="item.label"
								:label="item.label"
								border>
								{{item.desc}}
							</Radio>
						</RadioGroup>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="备注:" prop="remark">
            <Input v-model.trim="handleForm.remark" type="textarea" :rows="5" placeholder="请输入" maxlength="100" show-word-limit />
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import clone from 'clone'
import api from '../../api'

export default {
  name: 'AccountStatus',
  data () {
    return {
      modal: false,
      loading: false,
      statusList: [
        { label: 1, desc: '待对账' },
        { label: 2, desc: '已对账待付款' },
        { label: 3, desc: '付款完成' }

      ],
      currentRows: {},
      reconciliationType: 0, // 0 供应商流水,1 代理商流水
      handleForm: {
        status: null,
        remark: ''
      },
      handleValidate: {
        status: [
          { type: 'enum', enum: [1, 2, 3], required: true, message: '请选择一种状态', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    show (rows = {}, reconciliationType = 0) {
      this.currentRows = clone(rows)
      this.reconciliationType = reconciliationType
      this.modal = true
    },
    hide () {
      this.$refs['handleForm'].resetFields()
      this.loading = false
      this.modal = false
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      let queryParams = {}
      if (this.reconciliationType === 1) {
        // 是代理商
        this.handleForm.remark && (queryParams.agentReconciliationNotes = this.handleForm.remark)
        // queryParams.agentReconciliationNotes = this.handleForm.remark || undefined
        queryParams.agentReconciliationStatus = this.handleForm.status
      } else {
        // 是供应商
        this.handleForm.remark && (queryParams.reconciliationNotes = this.handleForm.remark)
        // queryParams.reconciliationNotes = this.handleForm.remark || undefined
        queryParams.reconciliationStatus = this.handleForm.status
      }
      queryParams.orderDetailIds = this.currentRows.map(item => item.id) || []
      // console.log('修改参数', queryParams)
      let submitApi = api.order.flowChange
      this.loading = true
      submitApi(queryParams).then(res => {
        this.$emit('success', this.action, {
          ...queryParams
        })
        this.$Message.success('修改成功！')
        this.hide()
      }).catch(err => {
        this.$Message.error('修改失败：' + err.message)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
